import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PLANS } from '../plans';
import BrandLogo from '../components/BrandLogo';
import './Auth.css';

export default function SignUp() {
  const { signup }  = useAuth();
  const navigate    = useNavigate();
  const [searchParams] = useSearchParams();
  const requestedPlan = PLANS[searchParams.get('plan')] || PLANS.launch;
  const [form, setForm]   = useState({ name: '', email: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await signup({ name: form.name, email: form.email, password: form.password });
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-root">
      <div className="auth-bg" />
      <div className="auth-card glass">
        <Link to="/" className="auth-back">← Back</Link>
        <BrandLogo className="auth-logo" />
        <h1 className="auth-title">Create account</h1>
        <p className="auth-sub">Create your account for the {requestedPlan.name} plan</p>
        {requestedPlan.name !== 'Launch' && <div className="auth-plan-note"><strong>{requestedPlan.name} · ${requestedPlan.price}/month</strong><span>Your account starts securely on Launch. Paid access is activated after billing and setup are confirmed.</span></div>}

        {error && <div className="auth-error">{error}</div>}

        <form className="auth-form" onSubmit={submit} noValidate>
          <div className="auth-field">
            <label htmlFor="name">Full Name</label>
            <input
              id="name" name="name" type="text"
              placeholder="Jane Smith"
              value={form.name} onChange={handle}
              autoComplete="name" required
            />
          </div>
          <div className="auth-field">
            <label htmlFor="email">Email</label>
            <input
              id="email" name="email" type="email"
              placeholder="you@example.com"
              value={form.email} onChange={handle}
              autoComplete="email" required
            />
          </div>
          <div className="auth-field">
            <label htmlFor="password">Password <span className="auth-hint">(min. 8 chars)</span></label>
            <input
              id="password" name="password" type="password"
              placeholder="••••••••"
              value={form.password} onChange={handle}
              autoComplete="new-password" required
            />
          </div>
          <div className="auth-field">
            <label htmlFor="confirm">Confirm Password</label>
            <input
              id="confirm" name="confirm" type="password"
              placeholder="••••••••"
              value={form.confirm} onChange={handle}
              autoComplete="new-password" required
            />
          </div>
          <button className="auth-btn" type="submit" disabled={loading}>
            {loading ? <span className="auth-spinner" /> : 'Create Account'}
          </button>
        </form>

        <p className="auth-switch">
          Already have an account?{' '}
          <Link to="/login">Sign in →</Link>
        </p>
      </div>
    </div>
  );
}
